/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  NUMBER_OF_STORIES,
  BUILDING_TYPE_DIR_1,
  BUILDING_TYPE_DIR_2,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import NumberOfStoriesWarning from './NumberOfStoriesWarning.jsx';

const mapStateToProps = (state, ownProps) => {
  const { selectFormValues } = modelTypesByForm[ownProps.form];
  return {
    numberOfStories: parseInt(selectFormValues(state, NUMBER_OF_STORIES), 10),
    buildingTypeDir1: selectFormValues(state, BUILDING_TYPE_DIR_1),
    buildingTypeDir2: selectFormValues(state, BUILDING_TYPE_DIR_2),
  };
};

export default connect(mapStateToProps)(NumberOfStoriesWarning);
